module.exports = __webpack_public_path__ + "static/media/team-member-04.887d8bf8.png";